<div class="outer-container">

  <lib-title-bar [crumbs]="[{ 'label': 'Digital Wallets' }, { 'label': 'Google Pay Certificate' }]">
  </lib-title-bar>

  <div class="details-container">
    <form class="form" [formGroup]="certificateForm" [libVituForm]="certificateForm" (libVituFormSubmit)="onSubmit()">
      <div class="form-inner-container">

        <div>

          <lib-vitu-form-field-input
            class="field"
            id="gatewayMerchantId"
            [formGroup]="certificateForm"
            formFieldName="gatewayMerchantId"
            label="TID">
          </lib-vitu-form-field-input>

          <lib-vitu-form-field-input
            class="field"
            id="token"
            [formGroup]="certificateForm"
            formFieldName="token"
            label="Google Certificate Token">
          </lib-vitu-form-field-input>

        </div>

        <div>

          <mat-form-field class="form-field">
            <mat-label>Body</mat-label>
            <textarea
              matInput
              formControlName="body"
              cols="1000"
              rows="10">
            </textarea>
          </mat-form-field>
        </div>

        @if (response) {
          <div>
            <h3>Response:</h3>
            <pre>{{ response | json }}</pre>
          </div>
        }
      </div>

      <lib-vitu-form-buttons>

        <lib-vitu-form-submit-button
          label="Submit">
        </lib-vitu-form-submit-button>

      </lib-vitu-form-buttons>
    </form>
  </div>

</div>